
import {
  defineComponent,
  ref,
  computed,
  useContext,
  useStore,
  useAsync,
} from '@nuxtjs/composition-api'

import { Wishlist } from '~/assets/ts/items/wishlist'
import { getCountryCode } from '~/assets/ts/Locale'
import { AppointmentLink } from '~/assets/ts/appointment/AppointmentLink'
import { domainByCountry } from '~/assets/ts/Domains'

export default defineComponent({
  components: {},
  setup() {
    const {
      app: { i18n },
    } = useContext()

    const languageSwitch = ref(false as boolean)

    const availableLocales = computed(() => i18n.locales)

    const country: string = getCountryCode().toString()
    const fullCountryCode: string = getCountryCode(true).toString()

    const countryList: { code: string; url: string; text: string }[] = []
    const countries: string[] = ['beFr', 'beNl']

    for (const countryIdx in countries) {
      countryList.push({
        code: countries[countryIdx],
        url: domainByCountry(countries[countryIdx]),
        text: i18n
          .t('elements.discoverTheWorld.country.' + countries[countryIdx])
          .toString(),
      })
    }

    const store = useStore()

    store.dispatch('shoplogin/checkLocalStorage')

    const shopLoginStatus = computed(() => store.getters['shoplogin/isActive'])

    const itemsOnWishlist = computed(() => {
      if (typeof store.getters['wishlist/getNumber'] !== 'number') {
        return 0
      } else {
        return store.getters['wishlist/getNumber']
      }
    })

    useAsync(() => {
      new Wishlist().getList().then((wishlist: any) => {
        store.commit('wishlist/setNumber', wishlist.length)
      })
    })

    /**
     * Appointment
     */

    const appointmentLink = new AppointmentLink().getAppointmentOverview()

    return {
      languageSwitch,
      availableLocales,
      itemsOnWishlist,
      shopLoginStatus,
      country,
      fullCountryCode,
      countryList,
      appointmentLink,
    }
  },
})
